<template>
  <div class="container mx-auto h-full py-5">
    <ul class="grid grid-cols-12 gap-4">
      <li
        v-for="report in reports"
        :key="report.id"
        :class="
          report.disabled
            ? 'border-gray-400  rounded-md p-4 col-span-4  text-gray-400'
            : 'border-orange-200 hover:border-blue-200 rounded-md p-4 col-span-4 cursor-pointer hover:shadow-lg text-orange-800 hover:text-blue-800'
        "
        class="flex flex-col space-y-2 border"
        @click="generate(report.action)"
      >
        <div class="flex flex-row justify-between">
          <span class="font-semibold text-sm">{{ report.name }}</span>
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            v-html="report.icon"
          />
        </div>
        <span class="text-gray-700">{{ report.description }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import { format, differenceInYears } from "date-fns";
import XLSX from "xlsx";
import { getHeader, getFooter, formatMoney } from "../../../utils";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  beforeRouteEnter(to, from, next) {
    next();
  },
  data() {
    return {
      reports: [
        {
          id: "icontrato",
          name: "IMPRIMIR CONTRATO ",
          action: "icontrato",
          description: "IMPRIMIR CONTRATO ",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "hgenerales",
          name: "HOJA DE DATOS GENERALES",
          action: "hgenerales",
          description: "HOJA DE DATOS GENERALES",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "apersonal",
          name: "ACCIONES DE PERSONAL POR EMPLEADO",
          action: "apersonal",
          description: "ACCIONES DE PERSONAL POR EMPLEADO",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "bpago",
          name: "BOLETA DE PAGO DEL EMPLEADO",
          action: "bpago",
          description: "BOLETA DE PAGO DEL EMPLEADO",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "csalario",
          name: "CONSTANCIA DE SALARIO",
          action: "csalario",
          description: "CONSTANCIA DE SALARIO",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "isalario",
          name: "INCREMENTOS SALARIALES",
          action: "isalario",
          description: "INCREMENTOS SALARIALES",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "prangopagos",
          name: "PAGOS POR PLANILLA EN RANGO DE FECHAS DEL EMPLEADO",
          action: "prangopagos",
          description: "PAGOS POR PLANILLA EN RANGO DE FECHAS DEL EMPLEADO",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
        {
          id: "cisr",
          name: "CARTA DE ISR",
          action: "cisr",
          description: "CARTA DE ISR",
          icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" ></path>',
          disabled: true,
        },
      ],
    };
  },
  methods: {
    setData() {},
    generate(report) {
      switch (report) {
        case "icontrato":
          break;
        case "hgenerales":
          break;
        case "apersonal":
          break;
        case "bpago":
          break;
        case "csalario":
          break;
        case "isalario":
          break;
        case "prangopagos":
          break;
        case "cisr":
          break;
      }
    },
    generateReport(reportType, formName, formData) {
      switch (reportType) {
      }
    },
  },
};
</script>
